import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = {
  class: "wrapinner",
  id: "wrapinner"
};
const _hoisted_3 = {
  class: "wrapbox"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "videoBoxli"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "bottom"
};
const _hoisted_8 = {
  class: "videoName"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pblWindow = _resolveComponent("pblWindow");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${$data.pblBlue.indexOf(_ctx.$route.query.fid) > -1 ? 'pbl_blue' : 'pbl'}`)
  }, [_createElementVNode("div", {
    class: _normalizeClass(["topbg", 'topbg' + $data.singleform.deptId])
  }, null, 2), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "bottombg"
  }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "videoBox",
      onClick: $event => $options.clickItem(index)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_cache[0] || (_cache[0] = _createElementVNode("img", {
      src: "http://data.museum.chaoxing.com/micro-upload/ycsbwg/static/img/icon-3d.png",
      alt: ""
    }, null, -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(item.name), 1)])])])], 8, _hoisted_4);
  }), 256))])])]), $data.showWindow ? (_openBlock(), _createBlock(_component_pblWindow, {
    key: 0,
    modelData: $data.modelData,
    config: $data.config,
    detailUrl: $data.detailUrl,
    windowTop: $data.windowTop
  }, null, 8, ["modelData", "config", "detailUrl", "windowTop"])) : _createCommentVNode("", true)], 2);
}